import script from "./Admin-Role-Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin-Role-Edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__